import { render, staticRenderFns } from "./index.vue?vue&type=template&id=651dd54a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=651dd54a&prod&lang=scss&module=true"
import style1 from "./index.vue?vue&type=style&index=1&id=651dd54a&prod&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=651dd54a&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../touch/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "651dd54a",
  null
  
)

export default component.exports